import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/workflow/mutationTypes';

export default {
  [types.SET_WORKFLOWS]: createSetPropMutation('workflows', []),
  [types.CLEAR_WORKFLOWS]: createClearPropMutation('workflows', []),
};
